/* eslint-disable */
import React from "react";
import { motion } from "framer-motion";
import { Box, Paper, Typography, useTheme } from "@mui/material";

const Dashboard = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: theme.palette.mode === "dark" ? "#0f172a" : "#f9fafb",
        p: 3,
        transition: "background-color 0.3s",
      }}
    >
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 900,
              letterSpacing: "-0.025em",
              color: theme.palette.mode === "dark" ? "#ffffff" : "#111827",
            }}
          >
            Dashboard
          </Typography>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Typography
            variant="body1"
            sx={{
              mt: 1,
              color: theme.palette.mode === "dark" ? "#9ca3af" : "#6b7280",
            }}
          >
            Welcome to EBS Office Management System
          </Typography>
        </motion.div>
      </Box>

      {/* Placeholder Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 400,
            borderRadius: "16px",
            border: `2px dashed ${
              theme.palette.mode === "dark" ? "#334155" : "#d1d5db"
            }`,
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(30,41,59,0.5)"
                : "rgba(255,255,255,0.5)",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                mx: "auto",
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #f59e0b 0%, #eab308 100%)",
              }}
            >
              <Typography
                variant="h4"
                component="span"
                sx={{
                  fontWeight: "bold",
                  color: "#ffffff",
                }}
              >
                E
              </Typography>
            </Box>
            <Typography
              variant="h6"
              component="h3"
              sx={{
                fontWeight: 600,
                color: theme.palette.mode === "dark" ? "#ffffff" : "#111827",
              }}
            >
              Dashboard Coming Soon
            </Typography>
          </Box>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default Dashboard;
